import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SignalIcon, WifiIcon, BatteryFullIcon } from 'lucide-react';
import { phone } from '../../../data/communicationsHero';
const EASE = [0.23, 1, 0.32, 1] as const;
export function CommsPhone({
  isFR,
  className = ''
}: {
  isFR: boolean;
  className?: string;
}) {
  const reduce = useReducedMotion();
  const pick = (v: {
    fr: string;
    en: string;
  }) => isFR ? v.fr : v.en;
  return <div className={`relative w-full max-w-[220px] rounded-[34px] border-[6px] border-[#1B1D26] bg-[#262052] shadow-[0_30px_60px_-30px_rgba(30,20,90,0.7)] overflow-hidden ${className}`} role="img" aria-label={isFR ? 'Notifications BCITI sur l’écran verrouillé' : 'BCITI notifications on the lock screen'} data-id="element-2689" data-mp="3hx47zq5nwil7">
      {/* wallpaper */}
      <div className="absolute inset-0" aria-hidden="true" data-id="element-2690" data-mp="1wksy84giuifq">
        <div className="absolute -top-10 -left-10 w-48 h-48 rounded-full bg-[#5B4BE0] opacity-50 blur-3xl" data-id="element-2691" data-mp="1wi6s899a4azm" />
        <div className="absolute bottom-10 -right-10 w-44 h-44 rounded-full bg-[#8A6BE8] opacity-40 blur-3xl" data-id="element-2692" data-mp="1rnjact8s6eu0" />
        <div className="absolute top-1/3 left-1/4 w-32 h-32 rounded-full bg-[#1D1840] opacity-70 blur-2xl" data-id="element-2693" data-mp="2lc17m79dj9d9" />
      </div>

      <div className="relative px-3 pt-2 pb-5 min-h-[400px] flex flex-col" data-id="element-2694" data-mp="26fjtx9dppinj">
        <div className="flex items-center justify-between px-2 font-sans text-[9px] font-semibold text-white" data-id="element-2695" data-mp="2bdv6vszb099z">
          <span data-id="element-2696" data-mp="1xlx1nt8pqxj3">9:01</span>
          <span className="w-16 h-4 rounded-full bg-[#0E0F14]" aria-hidden="true" data-id="element-2697" data-mp="1xlf5sxpyqlbp" />
          <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-2698" data-mp="22df12cv38q1y">
            <SignalIcon className="w-2.5 h-2.5" data-id="element-2699" data-mp="1noixas02dz75" />
            <WifiIcon className="w-2.5 h-2.5" data-id="element-2700" data-mp="1npu12rtif6y9" />
            <BatteryFullIcon className="w-3 h-3" data-id="element-2701" data-mp="1sn3your1yox6" />
          </span>
        </div>
        <p className="text-center font-sans text-[11px] text-white/85 mt-7" data-id="element-2702" data-mp="1sl0yxj03lhf9">{pick(phone.date)}</p>
        <p className="text-center font-sans text-[46px] font-semibold text-white leading-none tracking-tight mt-1" data-id="element-2703" data-mp="1epyk26d9whqb">9:41</p>

        <div className="mt-6 space-y-2" data-id="element-2704" data-mp="3lbl4xvijs65r">
          {phone.notifications.map((n, i) => <motion.div key={n.title.en} initial={reduce ? false : {
          opacity: 0,
          y: 8,
          scale: 0.96
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 0.25,
          ease: EASE,
          delay: 0.6 + i * 0.25
        }} className="rounded-2xl bg-white/90 backdrop-blur px-3 py-2.5" data-id="element-2705" data-mp="3gl4r4aateiiv" data-mpi={i}>
              <div className="flex items-center justify-between" data-id="element-2706" data-mp="84t5087xlgh8">
                <span className="flex items-center gap-1.5 font-sans text-[9px] font-semibold text-[#121212]" data-id="element-2707" data-mp="35ym769yrrx4">
                  <span className="w-3.5 h-3.5 rounded-[4px] bg-[#4F46E5] flex items-center justify-center text-[6px] font-bold text-white" aria-hidden="true" data-id="element-2708" data-mp="3ubhzuevj6199">
                    A
                  </span>
                  BCITI
                </span>
                <span className="font-sans text-[8px] text-[#8A90A0]" data-id="element-2709" data-mp="2evskeyyceqie">{pick(phone.now)}</span>
              </div>
              <p className="font-sans text-[10px] font-semibold text-[#121212] mt-1" data-id="element-2710" data-mp="ue08sz4yn13x">{pick(n.title)}</p>
              <p className="font-sans text-[9px] text-[#4A5160] leading-snug" data-id="element-2711" data-mp="yf263afbh339">{pick(n.body)}</p>
            </motion.div>)}
        </div>
        <div className="mt-auto pt-6 flex flex-col items-center gap-2" aria-hidden="true" data-id="element-2712" data-mp="13cvfecbx2d7r">
          <span className="flex gap-1" data-id="element-2713" data-mp="185wsqfwh64p8">
            {[0, 1, 2].map(d => <span key={d} className="w-1 h-1 rounded-full bg-white/60" data-id="element-2714" data-mp="1d516zky9asmf" />)}
          </span>
          <span className="w-20 h-1 rounded-full bg-white/80" data-id="element-2715" data-mp="1i29pjmnbgyo7" />
        </div>
      </div>
    </div>;
}